import { render, staticRenderFns } from "./memberCom.vue?vue&type=template&id=2c80661a&scoped=true"
import script from "./memberCom.vue?vue&type=script&lang=js"
export * from "./memberCom.vue?vue&type=script&lang=js"
import style0 from "./memberCom.vue?vue&type=style&index=0&id=2c80661a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c80661a",
  null
  
)

export default component.exports